"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGlUniformArray = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Wrapper for webgl uniform.
 */
class AGlUniformArray {
    constructor(name, data, transpose = false) {
        this.name = name;
        this.data = data;
        this.transpose = transpose;
        this.isDirty = true;
        this.uniformLocation = null;
        this.changeId = Number.MIN_SAFE_INTEGER;
    }
    onContextLost() {
        this.isDirty = true;
        this.uniformLocation = null;
    }
    initialize(componentRenderer) {
        componentRenderer.addUniform(this);
        this.uniformLocation = componentRenderer.context.getUniformLocation(componentRenderer.program, this.name);
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => {
            if (this.uniformLocation == null) {
                rc_js_util_1._Debug.verboseLog(`failed to bind uniform "${this.name}" of type "${this.data.constructor.name}"`);
            }
        });
    }
    setData(data, changeId) {
        if (this.changeId === changeId) {
            return;
        }
        this.changeId = changeId;
        this.data = data;
        this.isDirty = true;
    }
}
exports.AGlUniformArray = AGlUniformArray;
//# sourceMappingURL=a-gl-uniform-array.js.map